import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Calculator from "@/components/Calculator";
import Benefits from "@/components/Benefits";
import MortgageTypes from "@/components/MortgageTypes";
import Process from "@/components/Process";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import Variants from "@/components/Variants";
import MortgagePage from "@/components/MortgagePage";
import AdminPage from "@/components/AdminPage";
import LegalPage from "@/components/LegalPage";
import { scrollToId } from "@/lib/scroll";

function Landing() {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo) {
            const t = setTimeout(
                () => scrollToId(location.state.scrollTo),
                350
            );
            return () => clearTimeout(t);
        }
    }, [location.state]);

    return (
        <div className="min-h-screen bg-white" data-testid="keypoteca-app">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <HowItWorks />
                <Calculator />
                <Benefits />
                <MortgageTypes />
                <Process />
                <About />
                <Testimonials />
                <LeadForm />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/hipotecas/:slug" element={<MortgagePage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/legal/:doc" element={<LegalPage />} />
                <Route path="/variantes" element={<Variants />} />
                <Route
                    path="/necesitas-liquidez"
                    element={<MortgagePage slug="necesitas-liquidez" />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}

export default App;
